// extracted by mini-css-extract-plugin
export default {"video":"IntroVideo_video__s5HMN","muteButton":"IntroVideo_muteButton__vA7+r"};